import React from 'react'
import { Box } from '@usap/uicomponents'
import {
  SectionHeaderContainer,
  SectionHeader,
} from './style/SectionTitle.css'

export default function SectionTitle({
  title, id, hdBgMobile = '#ffffff', bxBgMobile = '#ffffff',
}) {
  return (
    <SectionHeaderContainer id={`${id}Section`} bxBgMobile={bxBgMobile}>
      <Box
        direction="row"
        width="1248px"
        margin={{ horizontal: 'auto', vertical: '0px' }}
        border={{ side: 'top', color: 'light-3', size: 'xsmall' }}
        justify="center"
      >
        <SectionHeader id={id} hdBgMobile={hdBgMobile}>{title}</SectionHeader>
      </Box>
    </SectionHeaderContainer>
  )
}
